// LogoutButton.tsx
import { Button, CircularProgress } from '@mui/material';
import { useState } from 'react';
import { useAuth } from './useAuth';

export default function LogoutButton() {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const auth = useAuth();

  // Use this pattern to satisfy the ESLint rule
  const handleLogout = () => {
    setIsLoggingOut(true);
    void (async () => {
      try {
        await auth.logout();
      } catch (error) {
        console.error('Logout error:', error);
      }
    })();
  };

  return (
    <Button
      variant={'contained'}
      color={'secondary'}
      onClick={handleLogout} // This is now a void function
      disabled={isLoggingOut}
      sx={{ borderRadius: 2, px: 3, position: 'relative' }}
    >
      {isLoggingOut && (
        <CircularProgress
          size={24}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
          }}
        />
      )}
      {isLoggingOut ? 'Logging out...' : 'Logout'}
    </Button>
  );
}
